import i18next from 'i18next';
import { initI18n } from '@wix/wix-i18n-config';

let promise;
const loaded = false;
let instance;

const isBrowser = () => typeof window !== 'undefined';
// export default function i18n(locale, pathName) {
//   let translatePath = '';
//   switch (pathName) {
//     case '/builder':
//       translatePath = 'backoffice';
//       break;
//     case '/settings':
//       translatePath = 'settings';
//       break;
//     case '/mobile':
//       translatePath = 'widget';
//       break;
//     default:
//       translatePath = 'widget';
//       break;
//   }

//   if (loaded) {
//     return instance;
//   }
//   if (!promise) {
//     instance = i18next.createInstance();
//     instance.use({
//       type: 'backend',
//       read: (language, namespace, callback) => {
//         return import(
//           /* webpackMode: "eager" */ `./locales/${translatePath}_${language}.json`
//         )
//           .then((translation) => callback(null, translation))
//           .catch((error) => {
//             console.log('error is', error);
//             return callback(error);
//           });
//       },
//       /* parseMissingKeyHandler: (/!* lng, ns, key, fallbackValue *!/) => {
//         return '';
//       },*/
//     });
//     promise = instance
//       .init({
//         lng: locale,
//         fallbackLng: 'en',
//         keySeparator: false,
//         react: {
//           wait: false,
//           useSuspense: false,
//           transEmptyNodeValue: '',
//         },
//         saveMissing: true,
//         /* parseMissingKeyHandler: (/!* lng, ns, key, fallbackValue *!/) => {
//           return '';
//         },
//         missingKeyHandler: (/!* lng, ns, key, fallbackValue *!/) => {
//           return '';
//         },*/
//       })
//       .then(() => {
//         loaded = true;
//       });
//   }
//   if (isBrowser()) {
//     return instance;
//   }
//   throw promise;
// }

export const i18nICU = (locale) => {
  return initI18n({
    locale,
    asyncMessagesLoader: (aLocale) =>
      import(`./locales/widget_${aLocale}.json`),
  });
};

export default function i18n(locale, pathName) {
  let translatePath = '';
  switch (pathName) {
    case '/builder':
      translatePath = 'backoffice';
      break;
    case '/settings':
      translatePath = 'settings';
      break;
    case '/mobile':
      translatePath = 'widget';
      break;
    default:
      translatePath = 'widget';
      break;
  }

  void i18next
    .use(initI18n)
    .use({
      type: 'backend',
      read: (language, namespace, callback) => {
        return import(`./locales/${translatePath}_${language}.json`)
          .then((translation) => {
            callback(null, translation);
          })
          .catch((error) => {
            callback(error);
          });
      },
    })
    .init({
      lng: locale,
      fallbackLng: 'en',
      keySeparator: false,
    });
  return i18next;
}
